module.exports = __webpack_public_path__ + "img/worksbot_img19112531.7d29a248.jpg";